export const NotificationTemplateColumns = [
  'name',
  'codeName',
  'cc',
  'bcc',
  'emailTitle',
  'chineseEmailTitle',
];
